<template>
  <section class="">
    <v-btn
      x-small
      color="primary"
      :dark="false"
      class="text-white py-4"
      @click="openModalSignContract(false)"
      v-if="
        isPresale &&
          isPresaleBusinessUnitResidential &&
          verifyExistDocumentsContractAndIdentityCard &&
          (currentUserIsSuperAdmin || permissionToSignContract) &&
          !contractWebdoxDocumentIsSigned
      "
    >
      <i class="mdi mdi-draw me-1"></i>
      Firmar Contrato
    </v-btn>
    <v-tooltip top v-if="contractWebdoxDocumentIsSigned">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="openModalSignContract(true)"
          x-small
          color="primary py-4"
          v-on="on"
          v-bind="attrs"
        >
          <v-icon color="white" class="me-1" x-small>
            mdi-eye-outline
          </v-icon>
          Revisar Contrato
        </v-btn>
      </template>
      Contrato enviado a WebDox
    </v-tooltip>
    <!-- <modal-select-documents-to-compare
      :modalAction="dialogSelectDocumentsToCompare"
      :closeModalSelectDocumentsToCompare="closeModalSelectDocumentsToCompare"
      :currentPresale="currentPresale"
      :folderWithDocuments="documents"
      @documentsToCompare="openModalSignContract"
      ref="modalSelectDocumentsToCompare"
    ></modal-select-documents-to-compare> -->
    <modal-sign-contract
      :modalAction="dialogSignContract"
      :closeModalSignContract="closeModalSignContract"
      :currentPresale="currentPresale"
      ref="modalSignContract"
      :onlyReadContract="onlyReadContract"
    ></modal-sign-contract>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import roles from "@/mixins/roles";
// import ModalSelectDocumentsToCompare from "./ModalSelectDocumentsToCompare.vue";
import ModalSignContract from "./ModalSignContract.vue";
import {
  GROUPS_USER_MANAGMENT,
  MIN_GROUP_TO_SIGN_CONTRACT,
} from "@/constants/approval";
import { authUsuarioComputed } from "@/state/helpers";
import { 
  COST_CENTER_RESIDENTIAL_COM,
  COST_CENTER_RESIDENTIAL_COM_V2
} from "@/constants/common";
import {
  BUSINESS_UNIT_RESIDENTIAL_CODE,
  NAME_FOLDER_SALE_RESIDENTIAL,
  NAME_FILE_CONTRACT,
  NAME_FILE_IDENTITY_CARD,
} from "@/constants/presale";

export default {
  name: "SignContract",
  mixins: [roles],
  components: {
    // ModalSelectDocumentsToCompare,
    ModalSignContract,
  },
  data() {
    return {
      // dialogSelectDocumentsToCompare: false,
      dialogSignContract: false,
      onlyReadContract: false,
    };
  },
  props: {
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // openModalSelectDocumentsToCompare() {
    //   this.$refs.modalSelectDocumentsToCompare.preselectDocumentsDefault();
    //   this.dialogSelectDocumentsToCompare = true;
    // },
    // closeModalSelectDocumentsToCompare() {
    //   this.dialogSelectDocumentsToCompare = false;
    // },
    openModalSignContract(onlyReadContract) {
      this.onlyReadContract = onlyReadContract;
      if (!onlyReadContract) {
        this.$refs.modalSignContract.sendValidateDocumentsPresale();
      }
      this.$refs.modalSignContract.setDocumentsToCompare(
        this.documentsContractAndIdentityCard
      );
      this.dialogSignContract = true;
    },
    closeModalSignContract() {
      this.onlyReadContract = false;
      this.dialogSignContract = false;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      currentPresale: "presale/presale",
      documents: "document/documents",
      dataEmployees: "maintainers/employees",
      contractWebdoxDocument: "presale/contractWebdoxDocument",
    }),
    documentsContractAndIdentityCard() {
      return this.documents.length
        ? this.documents[0].children
            .find((folder) => folder.name == NAME_FOLDER_SALE_RESIDENTIAL)
            ?.folder_document_types.filter(
              (document_type) =>
                (document_type.document_type.name == NAME_FILE_CONTRACT ||
                  document_type.document_type.name ==
                    NAME_FILE_IDENTITY_CARD) &&
                document_type.documents.length
            )
        : [];
    },
    isPresaleBusinessUnitResidential() {
      return (
        this.currentPresale &&
        this.currentPresale.business_unit.code ===
          BUSINESS_UNIT_RESIDENTIAL_CODE
      );
    },
    verifyExistDocumentsContractAndIdentityCard() {
      return (
        this.documents.length &&
        this.documents[0].children
          .find((folder) => folder.name == NAME_FOLDER_SALE_RESIDENTIAL)
          ?.folder_document_types.filter(
            (document_type) =>
              (document_type.document_type.name == NAME_FILE_CONTRACT ||
                document_type.document_type.name == NAME_FILE_IDENTITY_CARD) &&
              document_type.documents.length
          ).length >= 2
      );
    },
    permissionToSignContract() {
      return (
        this.dataEmployees.employees.length &&
        this.dataEmployees.employees.find(
          (employee) =>
            (employee.cost_center.code == COST_CENTER_RESIDENTIAL_COM ||
            employee.cost_center.code == COST_CENTER_RESIDENTIAL_COM_V2) &&
            employee.category &&
            GROUPS_USER_MANAGMENT[employee.category.name] <=
              MIN_GROUP_TO_SIGN_CONTRACT
        )
      );
    },
    contractWebdoxDocumentIsSigned() {
      return (
        this.contractWebdoxDocument &&
        this.contractWebdoxDocument.data &&
        this.contractWebdoxDocument.data.webdox_reference !== null
      );
    },
  },
};
</script>

<style></style>
